<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user.js";
    import PageInfo from "../components/pages/PageInfo.svelte";

    let request = null;
    let success = false;
    let errorIcon = null;
    let errorTitle = null;
    let errorMessage = null;

    const load = () => {
        const onSuccess = result => {
            user.setUser(result);
            success = true;
        }

        const onFailure = err => {
            if (err.code === 'not_found') {
                errorTitle = "Not found";
                errorMessage = "Could not find your request!";
                return;
            }

            if (err.code === 'request_expired') {
                errorTitle = "Invalid request";
                errorMessage = "This request has been expired!";
                return;
            }

            if (err.code === 'request_completed') {
                errorTitle = "Invalid request";
                errorMessage = "This request has been completed!";
                return;
            }

            if (err.code === 'same_object_identifier') {
                errorIcon = 'user';
                errorTitle = "Account exist";
                errorMessage = "There is already a member account with the email you specified!";
            }
        };

        R.handle(R.actionRequest.confirm, request, onSuccess, onFailure, LOADER.PAGE);
    }

    if (!$user.token) {
        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('request')) {
            request = searchParams.get('request');
        }

        load();
    }
</script>

<div class="page-header solid">
    <h1>Registration Completed</h1>
</div>
<div class="page solid">
    {#if $user.token && !success}
        <PageInfo message="you are already logged in to your account" icon="user" showCheckin showDashboard />
    {:else}
        {#if success}
            <PageInfo type="success" icon="check" title="Your registration process is complete." message="You are signed in to your account." showCheckin showDashboard/>
        {:else if errorMessage}
            <PageInfo icon="{ errorIcon }" title="{ errorTitle }" message="{ errorMessage }" />
        {/if}
    {/if}
</div>